import _extends from '@babel/runtime/helpers/esm/extends';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _styled from '@emotion/styled-base';
import 'core-js/modules/es6.object.to-string.js';
import 'core-js/modules/es6.array.iterator.js';
import 'core-js/modules/web.dom.iterable.js';
import 'core-js/modules/es6.regexp.to-string.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import React__default, { useState, useRef, useEffect } from 'react';
import { keymap, lineNumbers, crosshairCursor, drawSelection, dropCursor, highlightActiveLine, highlightActiveLineGutter, highlightSpecialChars, EditorView, rectangularSelection } from '@codemirror/view';
import { EditorState } from '@codemirror/state';
import { defaultKeymap, historyKeymap, history, indentWithTab } from '@codemirror/commands';
import { foldKeymap, foldGutter, bracketMatching, indentOnInput, syntaxHighlighting, defaultHighlightStyle } from '@codemirror/language';
import { closeBracketsKeymap, completionKeymap, autocompletion, closeBrackets, snippet } from '@codemirror/autocomplete';
import { searchKeymap, highlightSelectionMatches } from '@codemirror/search';
import { lintKeymap, lintGutter } from '@codemirror/lint';
import { border, borderRadiusMedium, backgroundMidtone, borderRadiusExtraSmall, text, borderRadiusSmall, intentPrimaryTranslucentActive, intentDanger, intentWarning, neutral } from '../theme/theme.js';
import { InfoTooltip } from '../info-tooltip/info-tooltip.js';
import cx from 'classnames';

var _excluded = ["actions", "allowMultipleSelections", "autocompletion", "autocompletionConfig", "bracketMatching", "className", "closeBrackets", "closeBracketsKeymap", "completionKeymap", "crosshairCursor", "defaultKeymap", "foldGutter", "foldKeymap", "drawSelection", "dropCursor", "editorHeight", "editorMaxHeight", "editorMinHeight", "editorRef", "extensions", "hideInfoTooltip", "hideToolbar", "highlightActiveLine", "highlightActiveLineGutter", "highlightSelectionMatches", "highlightSpecialChars", "history", "historyKeymap", "id", "indentOnInput", "indentWithTab", "infoTooltipText", "lineNumbers", "lineWrapping", "lintGutter", "lintKeymap", "onUpdate", "readOnly", "rectangularSelection", "resizable", "searchKeymap", "syntaxHighlighting", "t", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TranslationKeys;

(function (TranslationKeys) {
  TranslationKeys["codeEditorInfoTooltipText"] = "varicent-design-system.vds-code-editor.vds-code-editor-info-tooltip-text";
})(TranslationKeys || (TranslationKeys = {}));

var defaultTranslation = _defineProperty({}, TranslationKeys.codeEditorInfoTooltipText, function () {
  return "Press Escape, then Tab or Shift-Tab to move focus outside of the code editor.";
});

var defaultTranslate = function defaultTranslate(arg) {
  return defaultTranslation[arg.id](arg.values);
};

var CodeEditorWrapper = /*#__PURE__*/_styled("div", {
  target: "e1ki0se10"
})("overflow:hidden;border:1px solid ", border, ";border-radius:", borderRadiusMedium, ";");

var CodeEditorToolbar = /*#__PURE__*/_styled("div", {
  target: "e1ki0se11"
})("display:flex;flex-direction:row;align-items:flex-start;gap:0.25rem;padding:0.25rem;background-color:", backgroundMidtone, ";border-bottom:1px solid ", border, ";.vds-info-tooltip-trigger{width:2rem;height:2rem;padding:0.5rem;margin-left:auto;border-radius:", borderRadiusExtraSmall, ";}");

var CodeEditorActions = /*#__PURE__*/_styled("div", {
  target: "e1ki0se12"
})({
  name: "1xwiazx",
  styles: "display:flex;flex-direction:row;align-items:center;flex-wrap:wrap;gap:0.25rem;"
});

var CodeEditor = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var actions = _ref.actions,
      _ref$allowMultipleSel = _ref.allowMultipleSelections,
      allowMultipleSelections = _ref$allowMultipleSel === void 0 ? true : _ref$allowMultipleSel,
      _ref$autocompletion = _ref.autocompletion,
      autocompletion$1 = _ref$autocompletion === void 0 ? true : _ref$autocompletion,
      _ref$autocompletionCo = _ref.autocompletionConfig,
      autocompletionConfig = _ref$autocompletionCo === void 0 ? {} : _ref$autocompletionCo,
      _ref$bracketMatching = _ref.bracketMatching,
      bracketMatching$1 = _ref$bracketMatching === void 0 ? true : _ref$bracketMatching,
      className = _ref.className,
      _ref$closeBrackets = _ref.closeBrackets,
      closeBrackets$1 = _ref$closeBrackets === void 0 ? true : _ref$closeBrackets,
      _ref$closeBracketsKey = _ref.closeBracketsKeymap,
      closeBracketsKeymap$1 = _ref$closeBracketsKey === void 0 ? true : _ref$closeBracketsKey,
      _ref$completionKeymap = _ref.completionKeymap,
      completionKeymap$1 = _ref$completionKeymap === void 0 ? true : _ref$completionKeymap,
      _ref$crosshairCursor = _ref.crosshairCursor,
      crosshairCursor$1 = _ref$crosshairCursor === void 0 ? true : _ref$crosshairCursor,
      _ref$defaultKeymap = _ref.defaultKeymap,
      defaultKeymap$1 = _ref$defaultKeymap === void 0 ? true : _ref$defaultKeymap,
      _ref$foldGutter = _ref.foldGutter,
      foldGutter$1 = _ref$foldGutter === void 0 ? true : _ref$foldGutter,
      _ref$foldKeymap = _ref.foldKeymap,
      foldKeymap$1 = _ref$foldKeymap === void 0 ? true : _ref$foldKeymap,
      _ref$drawSelection = _ref.drawSelection,
      drawSelection$1 = _ref$drawSelection === void 0 ? true : _ref$drawSelection,
      _ref$dropCursor = _ref.dropCursor,
      dropCursor$1 = _ref$dropCursor === void 0 ? true : _ref$dropCursor,
      editorHeight = _ref.editorHeight,
      editorMaxHeight = _ref.editorMaxHeight,
      editorMinHeight = _ref.editorMinHeight,
      editorRef = _ref.editorRef,
      extensions = _ref.extensions,
      hideInfoTooltip = _ref.hideInfoTooltip,
      hideToolbar = _ref.hideToolbar,
      _ref$highlightActiveL = _ref.highlightActiveLine,
      highlightActiveLine$1 = _ref$highlightActiveL === void 0 ? true : _ref$highlightActiveL,
      _ref$highlightActiveL2 = _ref.highlightActiveLineGutter,
      highlightActiveLineGutter$1 = _ref$highlightActiveL2 === void 0 ? true : _ref$highlightActiveL2,
      _ref$highlightSelecti = _ref.highlightSelectionMatches,
      highlightSelectionMatches$1 = _ref$highlightSelecti === void 0 ? true : _ref$highlightSelecti,
      _ref$highlightSpecial = _ref.highlightSpecialChars,
      highlightSpecialChars$1 = _ref$highlightSpecial === void 0 ? true : _ref$highlightSpecial,
      _ref$history = _ref.history,
      history$1 = _ref$history === void 0 ? true : _ref$history,
      _ref$historyKeymap = _ref.historyKeymap,
      historyKeymap$1 = _ref$historyKeymap === void 0 ? true : _ref$historyKeymap,
      id = _ref.id,
      _ref$indentOnInput = _ref.indentOnInput,
      indentOnInput$1 = _ref$indentOnInput === void 0 ? true : _ref$indentOnInput,
      _ref$indentWithTab = _ref.indentWithTab,
      indentWithTab$1 = _ref$indentWithTab === void 0 ? true : _ref$indentWithTab,
      infoTooltipText = _ref.infoTooltipText,
      _ref$lineNumbers = _ref.lineNumbers,
      lineNumbers$1 = _ref$lineNumbers === void 0 ? true : _ref$lineNumbers,
      _ref$lineWrapping = _ref.lineWrapping,
      lineWrapping = _ref$lineWrapping === void 0 ? true : _ref$lineWrapping,
      _ref$lintGutter = _ref.lintGutter,
      lintGutter$1 = _ref$lintGutter === void 0 ? true : _ref$lintGutter,
      _ref$lintKeymap = _ref.lintKeymap,
      lintKeymap$1 = _ref$lintKeymap === void 0 ? true : _ref$lintKeymap,
      onUpdate = _ref.onUpdate,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$rectangularSelec = _ref.rectangularSelection,
      rectangularSelection$1 = _ref$rectangularSelec === void 0 ? true : _ref$rectangularSelec,
      resizable = _ref.resizable,
      _ref$searchKeymap = _ref.searchKeymap,
      searchKeymap$1 = _ref$searchKeymap === void 0 ? true : _ref$searchKeymap,
      _ref$syntaxHighlighti = _ref.syntaxHighlighting,
      syntaxHighlighting$1 = _ref$syntaxHighlighti === void 0 ? true : _ref$syntaxHighlighti,
      _ref$t = _ref.t,
      t = _ref$t === void 0 ? defaultTranslate : _ref$t,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);

  var combinedClassName = cx("vds-code-editor", className);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      view = _useState2[0],
      setView = _useState2[1];

  var editor = useRef(null);
  /**
   * Inserts a given string at the current cursor position, then
   * places the cursor at the end or an offset of the end of the inserted value.
   * @param {string} text - String to be inserted.
   * @param {number} offset - An offset to place the cursor counting from the end of the string. Default to 0.
   */

  var insertTextAtCursor = function insertTextAtCursor(text) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (view) {
      var cursorPos = view.state.selection.ranges[0].from;
      view.dispatch({
        changes: {
          from: cursorPos,
          to: view.state.selection.ranges[0].to,
          insert: text
        },
        selection: {
          anchor: cursorPos + text.length - offset
        }
      }); // setTimeout is required to resolve the issue where some components capture focus (ie. DropdownMenu)

      setTimeout(function () {
        view.focus();
      }, 10);
    }
  };
  /**
   * Inserts a given function template (string with arguments) at the current cursor position.
   * @param {string} template - String to be inserted.
   */


  var insertFunctionAtCursor = function insertFunctionAtCursor(template) {
    if (view) {
      var cursorPos = view.state.selection.ranges[0];
      var insertFunctionTemplate = snippet(template);
      insertFunctionTemplate(view, {
        label: template
      }, cursorPos.from, cursorPos.to); // setTimeout is required to resolve the issue where some components capture focus (ie. DropdownMenu)

      setTimeout(function () {
        view.focus();
      }, 10);
    }
  };
  /**
   * Clear all the contents in the code editor.
   */


  var clearAll = function clearAll() {
    if (view) {
      view.dispatch({
        changes: {
          from: 0,
          to: view.state.doc.toString().length,
          insert: ""
        }
      });
    }
  };
  /**
   * CodeEditor Utilities.
   * These are internal instances and functions made available
   * externally via the editorRef prop.
   */


  if (editorRef) {
    editorRef.current = _objectSpread(_objectSpread({}, editorRef.current), {}, {
      insertTextAtCursor: insertTextAtCursor,
      insertFunctionAtCursor: insertFunctionAtCursor,
      clearAll: clearAll,
      view: view
    });
  }

  useEffect(function () {
    var _extensions = [];
    /**
     * Keymappings
     */

    closeBracketsKeymap$1 && _extensions.push(keymap.of(_toConsumableArray(closeBracketsKeymap)));
    completionKeymap$1 && _extensions.push(keymap.of(_toConsumableArray(completionKeymap)));
    defaultKeymap$1 && _extensions.push(keymap.of(_toConsumableArray(defaultKeymap)));
    foldKeymap$1 && _extensions.push(keymap.of(_toConsumableArray(foldKeymap)));
    historyKeymap$1 && _extensions.push(keymap.of(_toConsumableArray(historyKeymap)));
    lintKeymap$1 && _extensions.push(keymap.of(_toConsumableArray(lintKeymap)));
    searchKeymap$1 && _extensions.push(keymap.of(_toConsumableArray(searchKeymap)));
    /**
     * Gutter extensions order determines render order
     * in gutter (left to right).
     */

    lintGutter$1 && _extensions.push(lintGutter());
    lineNumbers$1 && _extensions.push(lineNumbers());
    foldGutter$1 && _extensions.push(foldGutter());
    allowMultipleSelections && _extensions.push(EditorState.allowMultipleSelections.of(true));
    autocompletion$1 && _extensions.push(autocompletion(autocompletionConfig));
    bracketMatching$1 && _extensions.push(bracketMatching());
    closeBrackets$1 && _extensions.push(closeBrackets());
    crosshairCursor$1 && _extensions.push(crosshairCursor());
    drawSelection$1 && _extensions.push(drawSelection());
    dropCursor$1 && _extensions.push(dropCursor());
    highlightActiveLine$1 && !readOnly && _extensions.push(highlightActiveLine());
    highlightActiveLineGutter$1 && !readOnly && _extensions.push(highlightActiveLineGutter());
    highlightSelectionMatches$1 && _extensions.push(highlightSelectionMatches());
    highlightSpecialChars$1 && _extensions.push(highlightSpecialChars());
    history$1 && _extensions.push(history());
    indentOnInput$1 && _extensions.push(indentOnInput());
    indentWithTab$1 && _extensions.push(keymap.of([indentWithTab]));
    lineWrapping && _extensions.push(EditorView.lineWrapping);
    onUpdate && _extensions.push(EditorView.updateListener.of(onUpdate));
    readOnly && _extensions.push(EditorState.readOnly.of(true), EditorView.editable.of(false));
    rectangularSelection$1 && _extensions.push(rectangularSelection());
    syntaxHighlighting$1 && _extensions.push(syntaxHighlighting(defaultHighlightStyle, {
      fallback: true
    }));
    /**
     * Additional extensions
     */

    extensions && _extensions.push(_toConsumableArray(extensions));
    /**
     * Theme
     */

    _extensions.push(EditorView.theme({
      "&.cm-editor.cm-focused": {
        outline: "none"
      },
      "&.cm-editor": {
        height: editorHeight !== null && editorHeight !== void 0 ? editorHeight : null,
        maxHeight: editorMaxHeight !== null && editorMaxHeight !== void 0 ? editorMaxHeight : null,
        overflow: resizable ? "hidden" : "visible",
        resize: resizable ? "vertical" : "none"
      },
      ".cm-scroller": {
        overflow: "auto",
        fontFamily: "'IBM Plex Mono', monospace",
        backgroundColor: readOnly ? backgroundMidtone : "transparent"
      },
      ".cm-gutters": {
        backgroundColor: backgroundMidtone,
        borderRightColor: border
      },
      ".cm-gutter, .cm-content": {
        minHeight: editorMinHeight !== null && editorMinHeight !== void 0 ? editorMinHeight : null
      },
      ".cm-content": {
        padding: "0.5rem 0"
      },
      ".cm-line": {
        padding: "0 0.5rem"
      },
      ".cm-tooltip": {
        overflow: "hidden",
        color: text,
        backgroundColor: backgroundMidtone,
        border: "1px solid ".concat(border),
        borderRadius: borderRadiusSmall
      },
      ".cm-tooltip-autocomplete ul li[aria-selected]": {
        color: text,
        backgroundColor: intentPrimaryTranslucentActive
      },
      ".cm-diagnostic-error": {
        borderColor: intentDanger
      },
      ".cm-diagnostic-warning": {
        borderColor: intentWarning
      },
      ".cm-diagnostic-info": {
        borderColor: neutral
      }
    }));

    var state = EditorState.create({
      doc: value,
      extensions: _extensions
    });
    setView(new EditorView({
      state: state,
      parent: editor.current
    }));
    return function () {
      return view === null || view === void 0 ? void 0 : view.destroy();
    };
  }, [editor]);
  return /*#__PURE__*/React__default.createElement(CodeEditorWrapper, _extends({
    className: combinedClassName,
    "data-test": id ? "code-editor-".concat(id) : undefined,
    ref: ref
  }, props), !hideToolbar && !readOnly && /*#__PURE__*/React__default.createElement(CodeEditorToolbar, {
    className: "vds-code-editor-toolbar",
    "data-test": id ? "code-editor-toolbar-".concat(id) : undefined
  }, actions && /*#__PURE__*/React__default.createElement(CodeEditorActions, {
    className: "vds-code-editor-custom-actions"
  }, actions), !hideInfoTooltip && /*#__PURE__*/React__default.createElement(InfoTooltip, {
    content: infoTooltipText ? infoTooltipText : t({
      id: TranslationKeys.codeEditorInfoTooltipText
    })
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "vds-code-editor-content",
    "data-test": id ? "code-editor-content-".concat(id) : undefined,
    ref: editor
  }));
});

export { CodeEditor };
//# sourceMappingURL=code-editor.js.map
